// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".frisbuy-popup-media .frisbuy-media-play{position:absolute;width:95px;height:95px;top:50%;left:50%;transform:translate(-50%,-50%);cursor:pointer}.frisbuy-video-wrapper{position:relative}.frisbuy-video-wrapper video{position:absolute;inset:0;width:100%;max-height:100%;-o-object-fit:cover;object-fit:cover}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
